import CreateCampaignInfoController from './controller/CreateCampaignInfoController.js'
const template = require('./createCampaignInfo.tpl.pug')

const createCampaignInfo = {
  controller: CreateCampaignInfoController,
  template: template(),
}

export default createCampaignInfo
